<div class="panel-container flex flex-col h-full">
  <div class="panel-header flex items-center gap-[12px] mb-[24px]">
    @if (linkMode) {
      <mat-icon (click)="close()" class="back-arrow cursor-pointer">arrow_back</mat-icon>
    }
    <h2 class="text-type-2">{{ linkMode ? 'Add requests' : 'Create change order' }}</h2>
  </div>

  @if (!linkMode) {
    <div class="form-section">
      <app-text-input
        [parentFormGroup]="form"
        controlName="orderNumber"
        label="Change order number"
        class="w-full mb-[20px]"
      />
      @if (selectedCorIds.size > 0) {
        <app-text-area
          [parentFormGroup]="form"
          [maxLength]="descriptionMaxLength"
          [showCharCount]="true"
          [error]="commentsError"
          controlName="comments"
          label="Description"
          class="w-full mb-[20px]"
        />
        <app-text-area
          [parentFormGroup]="form"
          [maxLength]="descriptionMaxLength"
          [showCharCount]="true"
          controlName="location"
          label="Location"
          class="w-full mb-[20px]"
        />
      }
    </div>
  }

  <div class="cor-picker flex-1">
    <label class="picker-label text-type-13 uppercase">Select change order requests</label>
    @if (availableCors.length) {
      <div class="cor-list">
        @for (cor of availableCors; track cor.id) {
          <div (click)="toggleCor(cor.id)" class="cor-item" [class.selected]="selectedCorIds.has(cor.id)">
            <mat-checkbox [checked]="selectedCorIds.has(cor.id)" color="primary" />
            <div class="cor-info flex-1">
              <div class="cor-name text-type-8">Request #{{ cor.request_no }}</div>
              <div class="cor-desc text-type-14">{{ cor.description }}</div>
            </div>
            <div class="cor-amount text-type-11">${{ cor.totalAmount | number:'1.2-2' }}</div>
          </div>
        }
      </div>
    } @else {
      <div class="no-cors text-type-14">No approved requests available</div>
    }
  </div>

  <div class="panel-actions flex gap-[12px] mt-[20px] pb-[10px]">
    <app-secondary-button (handleClick)="close()" class="flex-1">Cancel</app-secondary-button>
    <app-primary-button (handleClick)="confirm()" [isDisabled]="selectedCorIds.size === 0 || (!linkMode && form.invalid)" class="flex-1">
      {{ linkMode ? 'Link' : 'Create' }}
    </app-primary-button>
  </div>
</div>
